import PropTypes from 'prop-types';
import { ChevronRightIcon, PlusIcon } from '@heroicons/react/24/outline';

import Tooltip from '@/components/core/Tooltip';

// Two layout primitives local to the builder. Field is a compact stacked
// label/control for the dense TEA grid — core/form/FormRow is the shared
// equivalent but lays out horizontally and carries node-panel styling that
// doesn't apply here.

export const Field = ({ label, tooltip, children }) => (
  <div>
    <label className="flex items-center gap-1 text-[10px] font-medium text-gray-600 mb-0.5">
      {label}
      {tooltip ? <Tooltip label={label} text={tooltip} /> : null}
    </label>
    {children}
  </div>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export const SectionHeader = ({ title, tooltip, onAdd, collapsed, onToggle, preview }) => {
  const toggleable = typeof onToggle === 'function';
  const addable = typeof onAdd === 'function';
  // Kept out of the toggle's click so hovering / tapping the icon doesn't
  // collapse the section.
  const hint = tooltip ? (
    <span onClick={e => e.stopPropagation()}>
      <Tooltip label={title} text={tooltip} />
    </span>
  ) : null;
  return (
    <div className="flex items-center justify-between border-b border-gray-200 pb-1 mb-2">
      {toggleable ? (
        <button
          type="button"
          className="flex items-center gap-1 text-left flex-1 min-w-0"
          onClick={onToggle}
        >
          <ChevronRightIcon
            className={`h-3 w-3 text-gray-500 transition-transform ${collapsed ? '' : 'rotate-90'}`}
          />
          <h4 className="font-medium text-sm">{title}</h4>
          {hint}
          {collapsed && preview ? (
            <span className="text-xs text-gray-500 font-mono truncate ml-2">
              {preview}
            </span>
          ) : null}
        </button>
      ) : (
        <div className="flex items-center gap-1">
          <h4 className="font-medium text-sm">{title}</h4>
          {hint}
        </div>
      )}
      <div className="flex items-center gap-2">
        {addable && !collapsed && (
          <button type="button" className="btn btn-ghost btn-xs gap-1" onClick={onAdd}>
            <PlusIcon className="h-4 w-4" />
            Add
          </button>
        )}
      </div>
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  onAdd: PropTypes.func,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func,
  preview: PropTypes.string,
};
